import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// A tuft of tall grass — several thin tapered blades fanning out, swaying in the
// wind (rounded art style, plan 28 stage 4 — was thin boxes).
// Geometry only — spawn metadata (weight/mapColor/habitat/sway/…) lives in
// content/decos/grass.json; this build is registered in src/model/coded.ts.
const build: (ctx: DecoBuildCtx) => void = ({ bone, seed }) => {
    const base = shade(0x6a9b3f, (rand(seed) - 0.5) * 0.3);
    const count = 4 + Math.floor(rand(seed + 1) * 4);
    for (let i = 0; i < count; i++) {
      const a = rand(seed + i * 4) * Math.PI * 2;
      const r = rand(seed + i * 4 + 1) * 0.25;
      const h = 0.4 + rand(seed + i * 4 + 2) * 0.5;
      const lean = (rand(seed + i * 4 + 3) - 0.5) * 0.18;
      const x = Math.cos(a) * r, z = Math.sin(a) * r;
      // A thin blade planted at the ground, tapering to a fine tip that leans off.
      bone(x, 0, z, x + lean, h, z, 0.03, 0.01, shade(base, (rand(seed + i) - 0.5) * 0.2));
    }
  };

export default build;
